export const sex  = [
    {
        id:"1",
        description:"masculino"
    },
    {
        id:"2",
        description:"femenino"
    }
]